import React, { useEffect } from 'react';

/**
 * - Remove the tabindex attribute from the datepicker clear button.
 */
export function DatePickerAttributeInjector() {
    /**
     * Set tabindex for all buttons in the toast notifications
     */
    const removeCloseTabIndex = () => {
        const buttons = document.querySelectorAll('.datepicker-clear-button'); // The datepicker-clear-button class is used to identify the clear button
        buttons.forEach(button => {
            button.removeAttribute('tabindex'); // Remove existing tabindex to avoid conflicts
        });

        return buttons;
    };

    /**
     * Listen for changes in the DOM and remove tabindex for datepicker buttons
     */
    useEffect(() => {
        const observer = new MutationObserver(() => {
            removeCloseTabIndex();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Remove tabindex for existing buttons
        const buttons = removeCloseTabIndex();

        return () => {
            observer.disconnect();
        };
    }, []);

    return null;
}
